<template>
  <div id="memorial-payment">
    <h2 class="text-center">{{ $t('pages.memorial.promo') }}</h2>
    <b-container>
      <div class="private">
        <p>{{ $t('pages.memorial.promo_code.intro') }}</p>
        <form>
          <p v-html="$t('pages.memorial.promo_code.title')" />
          <b-input-group>
            <b-form-input
              v-model="code"
              :state="inputState"
              type="text"
            />
            <b-input-group-append>
              <b-btn
                variant="primary"
                type="submit"
                @click.prevent="checkCode()"
              >
                {{ $t('actions.check.code') }}
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-row>
            <b-col>
              <b-button
                block
                type="submit"
                variant="primary"
                @click.prevent="nextStep()"
              >
                {{ $t('actions.next') }}
              </b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </b-container>
  </div>
</template>

<script>
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';

  export default {
    name: 'MemorialPromo',
    components: {
      AjaxNew,
    },
    data() {
      const { id } = this.user().memorial;
      return {
        id,
        code: '',
        promoCode: null,
        name: 'subscription',
        inputState: null,
      };
    },
    computed: {
      modelPromoCode() {
        return { promo_code: this.promoCode };
      },
    },
    methods: {
      async checkCode() {
        this.output = this.code;
        const response = await this.$ajax.get(`api/memorial/${this.id}/promotion/${this.output}`);

        if (response.status === 'ok') {
          this.promoCode = this.output;
          this.$set(this, 'inputState', 'valid');
          this.$notify({
            title: this.$t('flashes.promo_code.valid'),
            text: this.$t('flashes.promo_code.text'),
            type: 'success',
          });
        } else {
          this.$set(this, 'inputState', 'invalid');
          this.$notify({
            title: this.$t('flashes.promo_code.invalid'),
            text: this.$t('flashes.promo_code.text_invalid'),
            type: 'error',
          });
        }
      },
      nextStep() {
        if (this.inputState === 'valid') {
          this.$ajax.refresh().then(() => {
            this.$router.push({ name: 'memorial.show', params: { id: this.id } });
            this.$parent.step = 0;
          });
        } else {
          this.$parent.step += 1;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  /deep/ form .vue-form-generator{
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Memorial/promo.vue